module.exports = __webpack_public_path__ + "static/meta-34033cf922c9dab91889161ecd653ef8.jpg";